export default __webpack_public_path__ + "static/media/The_Nest_large_3.bf833ff5.jpg";